const awsmobile = {
  aws_project_region: 'eu-west-1',
  aws_cognito_identity_pool_id:
    'eu-west-1:5f3a5f37-4696-4bd8-bbf4-31cb73568d92',
  aws_cognito_region: 'eu-west-1',
  aws_user_pools_id: 'eu-west-1_EPqE7OuFn',
  aws_user_pools_web_client_id: '7e8i2f7mffi61b3vs9n35aocmt',
  location_api_key: '300b3ec433e44aea99cc6e40fa02e0ddLXByb2Q=',
  location_endpoint_auth: 'https://www.loophome.app/location',
  smartmeter_endpoint_auth: 'https://www.loophome.app/smart-meter',
  trustpower_endpoint_auth: 'https://api-prod.tp.prod.trustpower.io',
  billing_endpoint_auth: 'https://www.loophome.app/billing',
  dvla_endpoint_auth:
    'https://www.loophome.app/dvla/vehicle-enquiry/v1/vehicles',
  user_domain_url: 'https://api-prod.user-domain.prod.trustpower.io',
};
export default awsmobile;
